<template >
  <v-card class="elevation-0">
    <v-layout row wrap fill-height align-center>
      <v-flex grow pl-2>
        <v-text-field v-model="search" solo flat :color="skin.primary_color" hide-details autofocus clearable
          class="ml-2" prepend-icon="search" :label="$t('Vehicle.Labels.SearchVehicle')"></v-text-field>
      </v-flex>

      <v-flex shrink class="ml-3 mr-3">
        <v-btn v-if="isVehicleSelected" :block="$isMobileDevice"
          :to="$ROUTES.CATALOG.replace(':provider', this.skin.provider)" class="white--text" large depressed
          :color="skin.primary_color">{{ $t('Vehicle.Actions.BrowseParts') }}</v-btn>
      </v-flex>
    </v-layout>

    <v-divider></v-divider>

    <v-layout shrink v-resize="onResize">
      <v-flex>
        <v-data-table :headers="headers" :items="filtered_vehicles" :loading="loading" :pagination.sync="pagination"
          class="readonly-table" item-key="id" :hide-headers="isMobile" :class="{ mobile: isMobile }">
          <v-progress-linear slot="progress" :color="skin.primary_color" indeterminate></v-progress-linear>
          <template slot="headers" slot-scope="props">
            <tr class="text-uppercase">
              <template v-for="header in props.headers">
                <th :style="`text-align: ${header.align ? header.align : 'center'}`" v-if="header.visibility"
                  :key="header.text"
                  :class="['column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '', header.class ? header.class : false]"
                  @click="$sortBy(pagination, header.value)">
                  <v-icon small>arrow_upward</v-icon>
                  {{ header.text }}
                </th>
              </template>
            </tr>
          </template>
          <template slot="items" slot-scope="props">
            <tr v-if="!isMobile" @click="SET_VEHICLE(props.item); selected = props.item"
              :active="!!selected && selected.id == props.item.id">
              <template v-if="props.item.ymme">
                <td style="display: none">{{ props.item.fulltext }}</td>
                <!-- <td class="dataVehicle">{{ props.item.date | moment('MM/DD/YY HH:mma') }}</td> -->
                <td class="dataVehicle">
                  <span class="ml-4">{{ props.item.ymme.year || '' }}</span>
                </td>
                <td class="dataVehicle">
                  <span class="ml-4">{{ props.item.ymme.make || '' }}</span>
                </td>
                <td class="dataVehicle">
                  <span class="ml-4">{{ props.item.ymme.model || '' }}</span>
                </td>
                <td class="dataVehicle">
                  <span class="ml-4">
                    {{ props.item.ymme.engine || '' }}
                  </span>

                </td>
                <td class="dataVehicle">
                  <span class="ml-4">

                    {{ props.item.vin || '' }}
                  </span>
                </td>
                <!-- <td class="dataVehicle hidden-lg-and-down text-xs-center">{{ props.item.licensePlate || '' }}</td>
                <td class="dataVehicle hidden-lg-and-down text-xs-center">{{ props.item.color || '' }}</td>
                <td class="dataVehicle hidden-lg-and-down text-xs-center">{{ props.item.description || '' }}</td>
                <td class="dataVehicle hidden-lg-and-down text-xs-center">{{ props.item.owner || '' }}</td>
                <td class="dataVehicle hidden-lg-and-down text-xs-center">{{ props.item.fleet || '' }}</td>
                <td class="dataVehicle hidden-lg-and-down text-xs-center">{{ props.item.odometerMileage || '' }}</td>
                <td class="dataVehicle hidden-lg-and-down text-xs-center">{{ props.item.mileageUnit || '' }}</td>
                <td class="dataVehicle hidden-lg-and-down">{{ props.item.tag || '' }}</td> -->
                <td class="dataVehicle text-xs-right actions">
                  <v-layout row wrap fill-height justify-end>
                    <v-flex class="dataVehicle" shrink>
                      <v-tooltip :color="skin.primary_color" bottom>
                        <!-- <v-btn
                          small
                          fab
                          icon
                          @click="showEditDialog(props.item.id)"
                          slot="activator"
                        >
                          <v-icon small>edit</v-icon>
                        </v-btn> -->
                        <span>Editar detalles del vehículo</span>
                      </v-tooltip>
                    </v-flex>
                    <v-flex class="dataVehicle" shrink>
                      <v-tooltip :color="skin.primary_color" bottom>
                        <v-btn small fab icon @click="browseCatalog(props.item); selected = props.item"
                          slot="activator">
                          <v-icon>launch</v-icon>
                        </v-btn>
                        <span>Explorar Catalogo</span>
                      </v-tooltip>
                    </v-flex>
                  </v-layout>
                </td>
              </template>
            </tr>
            <tr v-else @click="SET_VEHICLE(props.item); selected = props.item"
              :active="!!selected && selected.id == props.item.id">
              <td>
                <ul class="flex-content">
                  <!-- <li class="flex-item" data-label="DATE">{{ props.item.date | moment('MM/DD/YY HH:mma') }}</li> -->
                  <li class="flex-item mr-1" data-label="AÑO">{{ props.item.ymme.year }}</li>
                  <li class="flex-item" data-label="MARCA">{{ props.item.ymme.make }}</li>
                  <li class="flex-item" data-label="MODELO">{{ props.item.ymme.model }}</li>
                  <li class="flex-item" data-label="MOTOR">{{ props.item.ymme.engine }}</li>
                  <li class="flex-item" data-label="VIN">{{ props.item.vin }}</li>
                  <li class="actions">
                    <v-tooltip :color="skin.primary_color" bottom>
                      <!-- <v-btn small fab icon @click="showEditDialog(props.item.id)" slot="activator">
                        <v-icon x-small>edit</v-icon>
                      </v-btn> -->
                      <span>Editar detalles del vehículo</span>
                    </v-tooltip>
                  </li>
                  <li class="actions">
                    <v-tooltip :color="skin.primary_color" bottom>
                      <v-btn small fab icon @click="browseCatalog(props.item); selected = props.item" slot="activator">
                        <v-icon x-small>launch</v-icon>
                      </v-btn>
                      <span>Explorar Catalogo</span>
                    </v-tooltip>
                  </li>
                </ul>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>

    <v-layout>
      <v-flex text-xs-right class="mr-3 ml-3">
        <v-btn :disabled="!isVehicleSelected" :block="$isMobileDevice"
          :to="$ROUTES.CATALOG.replace(':provider', this.skin.provider)" class="white--text " large depressed
          :color="skin.primary_color">{{ $t('Vehicle.Actions.BrowseParts') }}</v-btn>
      </v-flex>
    </v-layout>
  </v-card>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";

export default {
  name: "ExistingVehicle",
  data() {
    return {
      search: "",
      loading: false,
      selected: {},
      dialog: false,
      pagination: {
        descending: true,
        page: 1,
        rowsPerPage: 25,
        sortBy: "id"
      },
      isMobile: false,
    }
  },
  async mounted() {
    this.loading = true;
    await this.$store.dispatch("vehicle/GET_YMME_DATA", { service: 'vehicles' });
    this.loading = false;
  },
  computed: {
    ...mapState({
      vehicles: state => state.vehicle.vehicles,
      skin: state => state.settings.skin
    }),
    ...mapGetters({
      isVehicleSelected: "vehicle/isVehicleSelected"
    }),
    filtered_vehicles() {
      return this.vehicles.filter(
        vehicle => vehicle.fulltext.toLowerCase().includes(this.search.toLowerCase()));
    },
    headers() {
      return [
        {
          text: "Fulltext",
          value: "fulltext",
          width: "1%",
          visibility: false
        },
        // {
        //   text: this.$i18n.tc("Vehicle.ExistingVehicle.Table.Headers.Date"),
        //   value: "date",
        //   width: "1%",
        //   align: "left",
        //   visibility: true
        // },
        {
          text: this.$i18n.tc("Vehicle.ExistingVehicle.Table.Headers.Year"),
          value: "ymme.year",
          width: "1%",
          align: "left",
          visibility: true
        },
        {
          text: this.$i18n.tc("Vehicle.ExistingVehicle.Table.Headers.Make"),
          value: "ymme.make",
          width: "10%",
          align: "left",
          visibility: true
        },
        {
          text: this.$i18n.tc("Vehicle.ExistingVehicle.Table.Headers.Model"),
          value: "ymme.model",
          width: "1%",
          align: "left",
          visibility: true
        },
        {
          text: this.$i18n.tc("Vehicle.ExistingVehicle.Table.Headers.Engine"),
          value: "ymme.engine",
          width: "10%",
          align: "left",
          visibility: true
        },
        {
          text: this.$i18n.tc("Vehicle.ExistingVehicle.Table.Headers.VIN"),
          value: "vin",
          width: "1%",
          align: "left",
          visibility: true
        },
        // {
        //   text: this.$i18n.tc(
        //     "Vehicle.ExistingVehicle.Table.Headers.LicensePlate"
        //   ),
        //   value: "licensePlate",
        //   class: "hidden-lg-and-down",
        //   align: "left",
        //   visibility: true
        // },
        // {
        //   text: this.$i18n.tc("Vehicle.ExistingVehicle.Table.Headers.Color"),
        //   value: "color",
        //   class: "hidden-lg-and-down",
        //   align: "left",
        //   visibility: true
        // },
        // {
        //   text: this.$i18n.tc(
        //     "Vehicle.ExistingVehicle.Table.Headers.Description"
        //   ),
        //   value: "description",
        //   class: "hidden-lg-and-down",
        //   align: "left",
        //   visibility: true
        // },
        // {
        //   text: this.$i18n.tc("Vehicle.ExistingVehicle.Table.Headers.Owner"),
        //   value: "owner",
        //   class: "hidden-lg-and-down",
        //   align: "left",
        //   visibility: true
        // },
        // {
        //   text: this.$i18n.tc("Vehicle.ExistingVehicle.Table.Headers.Fleet"),
        //   value: "fleet",
        //   class: "hidden-lg-and-down",
        //   align: "left",
        //   visibility: true
        // },
        // {
        //   text: this.$i18n.tc("Vehicle.ExistingVehicle.Table.Headers.Odometer"),
        //   value: "odometerMileage",
        //   class: "hidden-lg-and-down",
        //   align: "left",
        //   visibility: true
        // },
        // {
        //   text: this.$i18n.tc("Vehicle.ExistingVehicle.Table.Headers.Mileage"),
        //   value: "mileageUnit",
        //   class: "hidden-lg-and-down",
        //   align: "left",
        //   visibility: true
        // },
        // {
        //   text: this.$i18n.tc("Vehicle.ExistingVehicle.Table.Headers.Tag"),
        //   value: "tag",
        //   class: "hidden-lg-and-down",
        //   align: "left",
        //   visibility: true
        // },
        // {
        //   text: "",
        //   value: null,
        //   sortable: false,
        //   align: "left",
        //   width: "20%",
        //   visibility: true
        // }
      ];
    }
  },
  methods: {
    ...mapActions({
      TOGGLE_MODAL_STATE: "modals/TOGGLE_MODAL_STATE",
      SET_VEHICLE: "vehicle/SET_VEHICLE",
      GET_YMME_DATA: "vehicle/GET_YMME_DATA",
      TOGGLE_SPINNER: "spinner/TOGGLE_SPINNER"
    }),

    // async showEditDialog(id) {
    //   this.TOGGLE_SPINNER({ active: true, message: this.$i18n.tc("LoadingSpinner.LoadingVehicle") });
    //   await this.GET_YMME_DATA({ service: "vehicleID", params: { vehicleID: id } });
    //   await this.TOGGLE_MODAL_STATE({ name: "editVehicle", value: true });
    //   this.TOGGLE_SPINNER({ active: false });
    // },

    async browseCatalog(vehicle) {
      await this.SET_VEHICLE(vehicle);
      this.TOGGLE_SPINNER({ active: true, message: this.$i18n.tc("LoadingSpinner.LoadingParts") });
      await this.$router.push({ name: 'parts-lookup', params: { provider: this.skin.provider } });
      this.TOGGLE_SPINNER({ active: false });
    },
    onResize() {
      if (window.innerWidth < 767)
        this.isMobile = true;
      else
        this.isMobile = false;
    }
  }
};
</script>

<style lang="styluss" scoped>
</style>
     